import React from "react";
import { connect } from "react-redux";
import {
  serviceCaller,
  ServiceCallerProps,
  withLoginRedirect,
  ModalProps,
  withModals,
} from "../../composition";
import { firebaseConnect, isEmpty, isLoaded } from "react-redux-firebase";
import {
  Row,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  InputGroup,
  InputGroupText,
  Label,
} from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import get from "lodash.get";
import isEqual from "lodash.isequal";
import ISegment from "../../../types/services/ISegment";
import type { ISortOption } from "../../components/sortDropdown";
import ISortByType from "../../../types/services/ISortByType";
import Dashboard from "../../components/dashboard";
import Fragment from "../../../toolkit/fragment";
import classNames from "classnames";
import ReactTooltip from "react-tooltip";
import {
  getSegmentDonors,
  searchFlagById,
  updateSegmentMembersBatched,
} from "../../../utils/fetch";
import ISelectionUpdate from "../../../types/ISelectionUpdate";
import { ExportType } from "../exportModal";
import IUser from "../../../types/services/IUser";
import * as commonActions from "../../../utils/actions/common";
import { ScaleLoader } from "react-spinners";
import { condenseWhiteSpaces } from "../../../utils/commonFunctions";
import {
  isCurrentUserCollaborator,
  isCurrentUserOnlyCollaborator,
} from "../../../utils/roleCheck";
import IColumnName from "../../../types/IColumnName";
import {
  applyColumnPrefs,
  TableIds,
  toggleSavedColumn,
} from "../../../utils/tablePrefs";
import firebase from "firebase/compat/app";
import { moneyFormat } from "../../../utils/helpers";
import { withRouter } from "../../../utils/withRouter";
interface Props extends ServiceCallerProps, ModalProps {
  segment: ISegment;
  firebase: firebase.app.App;
  refreshDashboard: () => void;
  selectElement: (quantity: string, message: string) => void;
  flagIds: { [key: string]: boolean };
  allSegments: { [key: string]: ISegment }[];
}

interface State {
  selectAll: boolean;
  sortBy: ISortByType;
  sortAsc: boolean;
  selectedIds: string[];
  suppressedIds: string[];
  totalResult: number;
  segmentDonors: Array<IUser>;
  segmentDonorsIds: Array<String>;
  editedTitle: string;
  editTitle: boolean;
  fetchForSegment: boolean;
  loading: boolean;
  nameError: boolean;
  wipeData: boolean;
  columnNames: Array<IColumnName>;
  searchText: string;
  searchTextUsed: string;
  actionsMenuOpen: boolean;
}

const sortOptions: ISortOption[] = [
  { key: "ACCOUNT", show: "Contact #", colName: "accountNumber" },
  { key: "FIRST_NAME", show: "First Name", colName: "firstName" },
  { key: "LAST_NAME", show: "Last Name", colName: "lastName" },
  { key: "COMPANY", show: "Company", colName: "company" },
  { key: "PHONE", show: "Mobile #", colName: "phoneNumber" },
  { key: "EMAIL", show: "Email", colName: "email" },
  { key: "HIERARCHY", show: "Hierarchy", colName: "deliveryChannel" },
  { key: "CREATED", show: "Created On", colName: "createdOnPretty" },
];

class SegmentDonorList extends React.PureComponent<Props, State> {
  state = {
    sortBy: { key: "ACCOUNT", show: "Contact #", colName: "accountNumber" },
    selectAll: false,
    sortAsc: true,
    selectedIds: [],
    suppressedIds: [],
    totalResult: 0,
    segmentDonors: [],
    segmentDonorsIds: [],
    editedTitle: "",
    editTitle: false,
    fetchForSegment: true,
    loading: true,
    nameError: false,
    wipeData: false,
    columnNames: applyColumnPrefs(TableIds.segmentDonors, [
      { key: "Contact #", isDisabled: false },
      { key: "First Name", isDisabled: false },
      { key: "Last Name", isDisabled: false },
      { key: "Company", isDisabled: false },
      { key: "Mobile #", isDisabled: false },
      { key: "Email", isDisabled: false },
      { key: "Hierarchy", isDisabled: false },
      { key: "Created On", isDisabled: false },
    ]),
    searchTextUsed: "",
    searchText: "",
    actionsMenuOpen: false,
  };

  toggleActionsMenu = () => {
    this.setState({ actionsMenuOpen: !this.state.actionsMenuOpen });
  };

  searchTimeout = null;

  columnData = [
    "accountNumber",
    "firstName",
    "lastName",
    "company",
    "phoneNumber",
    "email",
    "deliveryChannel",
    "createdOnPretty",
  ];

  componentWillUnmount() {
    if (window) {
      window.removeEventListener("resize", this.handleWindowSize);
    }
  }

  handleWindowSize = () => {
    if (window) {
      if (window.innerWidth < 768) {
        this.setState({
          columnNames: applyColumnPrefs(
            TableIds.segmentDonors,
            this.props.segment && this.props.segment.isKeyword
              ? [
                  { key: "Contact #", isDisabled: false },
                  { key: "First Name", isDisabled: true },
                  { key: "Last Name", isDisabled: true },
                  { key: "Company", isDisabled: true },
                  { key: "Mobile #", isDisabled: false },
                  { key: "Created On", isDisabled: true },
                ]
              : [
                  { key: "Contact #", isDisabled: false },
                  { key: "First Name", isDisabled: true },
                  { key: "Last Name", isDisabled: true },
                  { key: "Company", isDisabled: true },
                  { key: "Mobile #", isDisabled: true },
                  { key: "Email", isDisabled: false },
                  { key: "Hierarchy", isDisabled: true },
                  { key: "Created On", isDisabled: true },
                ]
          ),
        });
      } else {
        this.setState({
          columnNames: applyColumnPrefs(
            TableIds.segmentDonors,
            this.props.segment && this.props.segment.isKeyword
              ? [
                  { key: "Contact #", isDisabled: false },
                  { key: "First Name", isDisabled: false },
                  { key: "Last Name", isDisabled: false },
                  { key: "Company", isDisabled: false },
                  { key: "Mobile #", isDisabled: false },
                  { key: "Created On", isDisabled: false },
                ]
              : [
                  { key: "Contact #", isDisabled: false },
                  { key: "First Name", isDisabled: false },
                  { key: "Last Name", isDisabled: false },
                  { key: "Company", isDisabled: false },
                  { key: "Mobile #", isDisabled: false },
                  { key: "Email", isDisabled: false },
                  { key: "Hierarchy", isDisabled: false },
                  { key: "Created On", isDisabled: false },
                ]
          ),
        });
      }
    }
  };

  selectAllCheck = e => {
    this.setState({
      selectAll: e.target.checked,
      selectedIds: [],
      suppressedIds: [],
    });
  };

  handleColumnHeaderSort = (accessor: string) => {
    const option = sortOptions.find(o => o.colName === accessor);
    if (!option) {
      return;
    }
    this.setState(prev => {
      const same = prev.sortBy.colName === option.colName;
      const sortAsc = same ? !prev.sortAsc : false;
      let segmentDonorsSorted = [...prev.segmentDonors];
      segmentDonorsSorted.sort(this.customCompare(option.colName));
      if (!sortAsc) {
        segmentDonorsSorted = segmentDonorsSorted.reverse();
      }
      return {
        sortBy: option,
        sortAsc,
        segmentDonors: segmentDonorsSorted,
      };
    }, () => {
      this.props.refreshDashboard();
    });
  };

  selectionUpdate = (update: ISelectionUpdate) => {
    this.setState({
      totalResult: update.totalAmount,
      selectedIds: update.selectedIds,
      suppressedIds: update.suppressedIds,
    });
  };

  execExport = () => {
    this.props.toggleExportModal(
      ExportType.segments,
      undefined,
      this.state.segmentDonors.length.toString(),
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      this.props.segment.isDonorList,
      this.props.flagIds ? Object.keys(this.props.flagIds) : [""],
      this.props.params.segmentId
    );
  };

  customCompare = fieldName => {
    return (a, b) => {
      if (!a[fieldName]) {
        return 1;
      } else if (!b[fieldName]) {
        return -1;
      } else if (a[fieldName] === b[fieldName]) {
        return 0;
      } else if (a[fieldName] < b[fieldName]) {
        return -1;
      } else {
        return 1;
      }
    };
  };

  componentDidMount() {
    if (
      this.props.config &&
      this.props.currentCharity &&
      this.props.segment &&
      this.props.serviceAccessToken
    ) {
      this.fetchDonors(null, "");
    }
    if (window) {
      this.handleWindowSize();
      window.addEventListener("resize", this.handleWindowSize);
    }
    if (this.props.currentCharity) {
      if (isCurrentUserOnlyCollaborator(this.props.currentCharity)) {
        this.props.navigate("/viewsparks");
      }
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (
      this.props.config &&
      this.props.currentCharity &&
      this.props.segment &&
      this.props.serviceAccessToken &&
      isEqual(prevState, this.state)
    ) {
      this.fetchDonors(prevProps.flagIds, prevState.searchTextUsed);
    }
    if (this.props.currentCharity) {
      if (isCurrentUserOnlyCollaborator(this.props.currentCharity)) {
        this.props.navigate("/viewsparks");
      }
    }

    if (prevState.searchTextUsed !== this.state.searchTextUsed) {
      this.fetchDonors(prevProps.flagIds, prevState.searchTextUsed);
    }
  }

  fetchDonors = async (prevIds, prevText) => {
    if (
      this.props.segment.isDonorList &&
      (!isEqual(prevIds, this.props.flagIds) ||
        prevText !== this.state.searchTextUsed)
    ) {
      let columnNames = this.state.columnNames;
      if (this.props.segment.isKeyword) {
        columnNames = applyColumnPrefs(TableIds.segmentDonors, [
          { key: "Contact #", isDisabled: false },
          { key: "First Name", isDisabled: false },
          { key: "Last Name", isDisabled: false },
          { key: "Company", isDisabled: false },
          { key: "Mobile #", isDisabled: false },
          { key: "Created On", isDisabled: false },
        ]);
        this.columnData = [
          "accountNumber",
          "company",
          "firstName",
          "lastName",
          "phoneNumber",
          "createdOnPretty",
        ];
      }
      let response = await searchFlagById(
        this.props.config.searchServiceUrl,
        this.props.currentCharity.id,
        this.props.params.segmentId,
        this.props.serviceAccessToken,
        this.state.searchTextUsed ? this.state.searchTextUsed : null
      );
      response = response.filter(donor => donor);
      response.sort(this.customCompare(this.state.sortBy.colName));
      if (!this.state.sortAsc) {
        response.reverse();
      }
      this.setState(
        {
          columnNames: columnNames,
          segmentDonors: response,
          segmentDonorsIds: this.props.flagIds
            ? Object.keys(this.props.flagIds)
            : [""],
          loading: false,
        },
        () => {
          this.props.refreshDashboard();
        }
      );
    } else if (
      this.props.segment &&
      !this.props.segment.isDonorList &&
      this.state.fetchForSegment
    ) {
      this.setState(
        {
          fetchForSegment: false,
        },
        () => {
          getSegmentDonors(
            this.props.config.searchServiceUrl,
            this.props.currentCharity.id,
            this.props.params.segmentId,
            this.props.serviceAccessToken
          ).then(response => {
            let newArray = [...response.result];
            newArray = newArray.filter(donor => donor);
            newArray.sort(this.customCompare(this.state.sortBy.colName));
            if (!this.state.sortAsc) {
              newArray.reverse();
            }
            this.setState(
              {
                segmentDonors: newArray,
                loading: false,
              },
              () => {
                this.props.refreshDashboard();
              }
            );
          });
        }
      );
    }
  };

  deleteDonors = () => {
    if (!this.state.selectAll && this.state.selectedIds.length === 0) {
      alert("Please select at least one donor to remove");
    } else {
      if (confirm("Are you sure you want to delete these contacts?")) {
        let deleteIds = [];
        if (this.state.selectAll && this.state.suppressedIds.length > 0) {
          deleteIds = this.props.flagIds
            ? [...Object.keys(this.props.flagIds)]
            : [];
          this.state.suppressedIds.forEach(elem => {
            const suppressedIndex = deleteIds.indexOf(elem);
            if (suppressedIndex >= 0) {
              deleteIds.splice(suppressedIndex, 1);
            }
          });
        } else if (this.state.selectAll) {
          deleteIds = this.props.flagIds
            ? [...Object.keys(this.props.flagIds)]
            : [];
        } else if (this.state.selectedIds.length > 0) {
          deleteIds = [...this.state.selectedIds];
          this.props.selectElement("0", "Donors Selected");
        }
        this.setState(
          {
            selectAll: false,
            selectedIds: [],
            suppressedIds: [],
            wipeData: true,
          },
          async () => {
            try {
              await updateSegmentMembersBatched(
                this.props.config.searchServiceUrl,
                this.props.currentCharity.id,
                this.props.params.segmentId,
                [],
                deleteIds,
                this.props.serviceAccessToken
              );
            } catch (error) {
              console.error(error);
              alert("Could not remove contacts from this list");
            }
            this.setState({
              wipeData: false,
            });
          }
        );
      }
    }
  };

  saveFlagName = async () => {
    if (this.state.editedTitle.length > 0) {
      const currentName = this.props.segment?.name ?? "";
      if (
        condenseWhiteSpaces(this.state.editedTitle.toUpperCase()) ===
        condenseWhiteSpaces(currentName.toUpperCase())
      ) {
        this.setState({
          editedTitle: "",
          editTitle: false,
          nameError: false,
        });
        return;
      }
      if (this.props.allSegments) {
        if (
          this.props.allSegments.some(segmentObject => {
            return (
              condenseWhiteSpaces(segmentObject.value.name.toUpperCase()) ===
                condenseWhiteSpaces(this.state.editedTitle.toUpperCase()) &&
              (!this.props.params.segmentId ||
                this.props.params.segmentId !== segmentObject.key)
            );
          })
        ) {
          this.setState({
            nameError: true,
          });
          return;
        }
      }
      await this.props.firebase
        .database()
        .ref()
        .child(this.props.currentCharity.id)
        .child("segments")
        .child(this.props.params.segmentId)
        .child("name")
        .set(this.state.editedTitle);
      this.setState({
        editedTitle: "",
        editTitle: false,
      });
    }
  };

  getResponse = (currentPage, pageSize) => {
    const result = [];
    for (
      let i = pageSize * currentPage;
      i < pageSize * (currentPage + 1) && i < this.state.segmentDonors.length;
      i++
    ) {
      result.push(this.state.segmentDonors[i]);
    }
    return Promise.resolve({
      result: result,
      totalAmount: this.state.segmentDonors.length,
      pageAmount: Math.ceil(this.state.segmentDonors.length / pageSize),
      time: Date.now(),
    });
  };

  handleChange = e => {
    this.setState({
      editedTitle: e.target.value,
      nameError: false,
    });
  };

  onEnterPressed = e => {
    if (e.keyCode === 13) {
      this.saveFlagName();
    } else if (e.keyCode === 27) {
      this.setState({
        editTitle: false,
        editedTitle: "",
        nameError: false,
      });
    }
  };

  editTitle = () => {
    this.setState({
      editTitle: true,
      editedTitle: this.props.segment.name,
    });
  };

  toggleModal = () => {
    this.props.toggleAddDonorModal(
      this.props.params.segmentId,
      this.state.segmentDonorsIds
    );
  };

  goBack = () => {
    if (this.props.params.fromSegments === "keyword") {
      this.props.navigate("/keywords");
    } else {
      this.props.navigate("/segments");
    }
  };

  disableColumn = index => {
    const copy = toggleSavedColumn(
      TableIds.segmentDonors,
      this.state.columnNames,
      index
    );
    this.setState(
      {
        columnNames: copy,
      },
      () => {
        this.props.columnsModalChange(this.state.columnNames);
      }
    );
  };

  changeColumns = () => {
    this.props.toggleColumnsModal(this.disableColumn, this.state.columnNames);
  };

  searchTextChange = e => {
    const newText: string = e.target.value;
    if (!newText || newText.length >= 3 || newText.length == 0) {
      if (this.searchTimeout && window) {
        window.clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }
      this.setState({
        searchText: newText,
        searchTextUsed: newText,
      });
    } else {
      if (window) {
        if (this.searchTimeout) {
          window.clearTimeout(this.searchTimeout);
        }
        this.setState({
          searchText: newText,
        });
        this.searchTimeout = window.setTimeout(() => {
          this.setState({
            searchTextUsed: newText,
          });
        }, 1500);
      }
    }
  };

  resetSearch = () => {
    this.setState({
      searchText: "",
      searchTextUsed: "",
    });
  };

  render() {
    const { segment } = this.props;

    let filters = "";
    if (this.props.segment && this.props.segment.recency) {
      filters +=
        (this.props.segment.recency.minValue
          ? this.props.segment.recency.minValue / 30
          : "0") + " - ";
      filters +=
        (this.props.segment.recency.maxValue
          ? this.props.segment.recency.maxValue / 30
          : "60+") + " months, ";
    }
    if (this.props.segment && this.props.segment.frequency) {
      filters +=
        (this.props.segment.frequency.minValue
          ? this.props.segment.frequency.minValue
          : "0") + " - ";
      filters +=
        (this.props.segment.frequency.maxValue
          ? this.props.segment.frequency.maxValue
          : "100") + " gifts, ";
    }
    if (this.props.segment && this.props.segment.amount) {
      filters +=
        "$" +
        (this.props.segment.amount.minValue
          ? `${moneyFormat(segment.amount.minValue / 100.0)}`
          : "0.00") +
        " - ";
      filters += this.props.segment.amount.maxValue
        ? "$" + `${moneyFormat(segment.amount.maxValue / 100.0)}`
        : "Any amount";
    }
    if (filters.endsWith(", ")) {
      filters = filters.substring(0, filters.length - 2);
    }
    return (
      <main className={s.main}>
        <div className={s.container}>
          <div className={s.pageHeader}>
            <div onClick={this.goBack} className={s.back}>
              <div className={s.arrowLeftContainer}>
                <div className={s.arrowLeft} />
              </div>
              <Label className={classNames(s.backLabel, s.cursor)}>
                Back
              </Label>
            </div>
            {!this.state.editTitle && this.props.segment && (
              <div className={s.titleGroup}>
                <span className={s.title}>
                  {this.props.segment.name ? this.props.segment.name : ""}
                </span>
                {isCurrentUserCollaborator(this.props.currentCharity) &&
                  !get(this.props.segment, "uneditable", false) &&
                  (this.props.segment
                    ? !this.props.segment.isKeyword
                    : true) && (
                    <button
                      type="button"
                      className={s.iconButton}
                      aria-label="Edit name"
                      title="Edit name"
                      onClick={this.editTitle}
                    >
                      <i className="fa fa-edit" aria-hidden="true" />
                    </button>
                  )}
                {filters ? <span className={s.filters}>{filters}</span> : null}
              </div>
            )}
            {this.state.editTitle && (
              <div className={s.titleGroup}>
                <div className={s.titleEdit}>
                  <Input
                    type="text"
                    name="text"
                    id="editedTitle"
                    value={this.state.editedTitle}
                    onChange={this.handleChange}
                    onKeyDown={this.onEnterPressed}
                    className={s.titleInput}
                  />
                  <button
                    type="button"
                    className={s.iconButton}
                    aria-label="Save name"
                    title="Save name"
                    onClick={this.saveFlagName}
                  >
                    <i className="fa fa-save" aria-hidden="true" />
                  </button>
                </div>
                {this.state.nameError && (
                  <Label className={s.error}>
                    Segment name must be unique
                  </Label>
                )}
              </div>
            )}
          </div>
          <div className={s.toolbar}>
            <div className={s.toolbarStart}>
              <div
                className={s.inlineDots}
                onClick={this.changeColumns}
                onKeyDown={e => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.changeColumns();
                  }
                }}
                role="button"
                tabIndex={0}
                data-tip
                data-for="segment-donors-column-mgmt"
                aria-label="Column management"
              >
                <i className={"fa fa-columns " + s.dotIcon}>&nbsp;</i>
              </div>
              <ReactTooltip
                id="segment-donors-column-mgmt"
                effect="solid"
                place="top"
              >
                Column management
              </ReactTooltip>
            </div>
            {this.props.segment && this.props.segment.isDonorList && (
              <InputGroup className={s.toolbarSearch}>
                <InputGroupText className={s.inputGroup}>
                  <i className={"fa fa-search " + s.searchIcon}>&nbsp;</i>
                </InputGroupText>
                <Input
                  id="searchText"
                  placeholder="Search Contact List"
                  value={this.state.searchText}
                  onChange={this.searchTextChange}
                  className={s.searchInput}
                />
                <InputGroupText className={s.inputGroupRight}>
                  <i
                    className={"fa fa-times " + s.closeIcon}
                    onClick={this.resetSearch}
                  >
                    &nbsp;
                  </i>
                </InputGroupText>
              </InputGroup>
            )}
            <Dropdown
              isOpen={this.state.actionsMenuOpen}
              toggle={this.toggleActionsMenu}
            >
              <DropdownToggle
                color="link"
                className={s.toolbarExtras}
                aria-label="More actions"
              >
                <i className="fa fa-ellipsis-v" />
              </DropdownToggle>
              <DropdownMenu right className={s.actionsDropdownMenu}>
                {this.props.segment &&
                  this.props.segment.isDonorList &&
                  !this.props.segment.isKeyword &&
                  isCurrentUserCollaborator(this.props.currentCharity) &&
                  !get(this.props.segment, "uneditable", false) && (
                    <DropdownItem onClick={this.toggleModal}>
                      Add Contact
                    </DropdownItem>
                  )}
                {this.props.segment &&
                  this.props.segment.isDonorList &&
                  isCurrentUserCollaborator(this.props.currentCharity) &&
                  !get(this.props.segment, "uneditable", false) && (
                    <DropdownItem onClick={this.deleteDonors}>
                      Remove Contact
                    </DropdownItem>
                  )}
                <DropdownItem onClick={this.execExport}>
                  Export All
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <Row>
            {this.props.serviceAccessToken &&
              this.props.config &&
              !this.state.loading && (
                <Dashboard
                  tableId={TableIds.segmentDonors}
                  columnNames={this.state.columnNames}
                  columnData={this.columnData}
                  selectionUpdate={this.selectionUpdate}
                  checkCol={
                    this.props.segment
                      ? this.props.segment.isDonorList &&
                        !get(this.props.segment, "uneditable", false)
                      : false
                  }
                  selectAllInCheckboxHeader
                  onSelectAllCheckboxChange={this.selectAllCheck}
                  suppressedIds={this.state.suppressedIds}
                  noDataText={"No Donors Found"}
                  infoCol={false}
                  sortBy={this.state.sortBy.colName}
                  selectAll={this.state.selectAll}
                  sortAsc={this.state.sortAsc}
                  columnHeaderSort={{
                    sortAccessor: this.state.sortBy.colName,
                    sortAscending: this.state.sortAsc,
                    sortableAccessors: sortOptions.map(o => o.colName),
                    onSort: this.handleColumnHeaderSort,
                  }}
                  footerMessage={
                    this.props.segment && this.props.segment.isDonorList
                      ? "Donors Selected"
                      : "Donors"
                  }
                  currentCharity={this.props.currentCharity}
                  getResponse={this.getResponse}
                  wipeData={this.state.wipeData}
                  deactivatedClassName={"deactivatedLabel"}
                />
              )}
            {this.state.loading && (
              <div
                className={
                  "d-flex full-width justify-content-center m-t-200 m-b-300 " +
                  s.center
                }
              >
                <ScaleLoader color={"#1f65b1"} loading />
              </div>
            )}
          </Row>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { firebase, user } = state;
  const segment = get(
    firebase,
    `data.${user.currentCharity.id}.segments.${props.params.segmentId}`
  );
  const flagIds =
    segment &&
    isLoaded(firebase.data[user.currentCharity.id]) &&
    isLoaded(firebase.data[user.currentCharity.id].donorsFlags) &&
    isLoaded(
      firebase.data[user.currentCharity.id].donorsFlags[segment.donorListId]
    )
      ? !isEmpty(
          firebase.data[user.currentCharity.id].donorsFlags[segment.donorListId]
        )
        ? get(
            firebase,
            `data.${user.currentCharity.id}.donorsFlags.${segment.donorListId}`
          )
        : []
      : null;
  const segments = !get(firebase, `data.${user.currentCharity.id}.segments`)
    ? null
    : get(firebase, `ordered.${user.currentCharity.id}.segments`);

  return {
    segment: segment,
    flagIds: flagIds,
    allSegments: segments,
  };
};

const mapDispatchToProps = dispatch => ({
  selectElement: (quantity = null, message = null) => {
    dispatch(commonActions.selectElement(quantity, message));
  },
  refreshDashboard: () => {
    dispatch(commonActions.refreshDashboard());
  },
});

export default serviceCaller(
  withLoginRedirect(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(
      withModals(
        firebaseConnect((props, store) => {
          const charityId = store.getState().user.currentCharity.id;
          const segmentId = props.params.segmentId;
          if (charityId && segmentId) {
            let paths = [
              { path: `${charityId}/segments/${segmentId}` },
              { path: `${charityId}/segments` },
            ];
            props.segment && props.segment.isDonorList
              ? paths.push({
                  path: `${charityId}/donorsFlags/${props.segment.donorListId}`,
                })
              : paths;
            return paths;
          } else {
            return [];
          }
        })(withStyles(s)(withRouter(SegmentDonorList)))
      )
    )
  )
);
